export default {
    identityIdPrefix: 'auth0|',
    localStorageKeys:{
        authToken: 'auth_token',
        currentUser: 'current_user'
    }
}